import { MessageCircle, Bot, Headphones } from "lucide-react";
import ProductPage from "@/components/ProductPage";
import {
  useDocumentTitle,
  DEFAULT_STEPS,
} from "@/lib/shared";

const FEATURES = [
  {
    Icon: MessageCircle,
    title: "Dale voz a tu Bot",
    desc: "Conectamos tus chatbots actuales (WhatsApp/Web) a la red telefónica con voz humana natural.",
  },
  {
    Icon: Bot,
    title: "Bots Transaccionales",
    desc: "Asistentes autónomos que agendan citas, procesan pagos o consultan saldos 24/7.",
  },
  {
    Icon: Headphones,
    title: "Agent Assist",
    desc: "La IA escucha la llamada en vivo y ayuda a tus agentes sugiriendo respuestas o buscando información al instante.",
  },
];

const VoiceAIPage = () => {
  useDocumentTitle("Caruna Voice AI — Automatización Inteligente");
  return (
    <ProductPage
      category="voice-ai"
      eyebrow="AUTOMATIZACIÓN E INTELIGENCIA"
      headline="Caruna Voice AI"
      subhead="Inteligencia Artificial: dale voz a tu estrategia digital."
      features={FEATURES}
      steps={DEFAULT_STEPS}
      integrations={["Microsoft Teams"]}
      ctaHeadline="Solicita una evaluación técnica de Caruna Voice AI"
      baseTech="Live Hub / Voice AI Connect"
      heroBody="Caruna Voice AI lleva la Inteligencia Artificial a cada punto de contacto de voz: conecta tus chatbots a la red telefónica, despliega asistentes autónomos 24/7 y potencia a tus agentes humanos con sugerencias en vivo durante la llamada."
    />
  );
};

export default VoiceAIPage;
